import ApplicationController from '../../application_controller.js';

export default class DeviceManagementController extends ApplicationController {
    DetectRTC = require('detectrtc');

    //checks if we can access a microphone and or camera
    checkDevicePermission({ audio = true, video = false } = {}) {
        return new Promise(function(resolve, reject) {
            DetectRTC.load(function() {
                const hasMicPermission = !audio || DetectRTC.isWebsiteHasMicrophonePermissions;
                const hasCameraPermission = !video || DetectRTC.isWebsiteHasWebcamPermissions;
    
                if (hasMicPermission && hasCameraPermission) {
                    resolve(true);
                } else {
                    reject('noPermission');
                }
            });
        });
    }

    // Requests permission to use the devices
    requestDevicePermission({ audio = true, video = false } = {}) {
        return new Promise(function(resolve, reject) {
            if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                var constraints = { video: video, audio: audio };
                navigator.mediaDevices.getUserMedia(constraints)
                    .then(function(stream) {
                        resolve(true);
                    })
                    .catch(function(error) {
                        reject(error);
                    });
            } else {
                reject('getUserMedia not supported');
            }
        });
    }

    getDevices() {
        return new Promise((resolve, reject) => {
           
          if (!navigator.mediaDevices?.enumerateDevices) {
            reject("enumerateDevices() not supported.");
          } else {
            navigator.mediaDevices.enumerateDevices()
              .then((devices) => {
                resolve(devices);
              })      
              .catch((err) => {
                reject(`${err.name}: ${err.message}`);
              });
          }
        });
      }

}